import {createSlice} from "@reduxjs/toolkit";
import {FAILED, LOADING, SUCCESS} from "../../common/statuses";
import {initialState} from "./initState";
import {GAME, getSettingByHWId, getTask, sendAnswer} from "./gameService";
import {errorConverter} from "../../common/formater";

const gameReducer = createSlice({
    name: GAME,
    initialState,
    reducers: {
        clearGameState: () => {
            return {...initialState};
        },
        setTheme: (state, action) => {
            state.setting.data.theme = action.payload;
        },
        setSolveType: (state, action) => {
            state.setting.data.solveType = action.payload;
        },
        setTaskType: (state, action) => {
            state.setting.data.taskType = action.payload;
        },
        setComplexity: (state, action) => {
            state.setting.data.complexity = action.payload;
        },
        setSpeed: (state, action) => {
            state.setting.data.speed = action.payload;
        },
        setLength: (state, action) => {
            state.setting.data.length = action.payload;
        },
        setClearTask: (state) => {
            state.task = {
                ...initialState.task
            }
        },
        setClearAnswer: (state) => {
            state.answer = {
                ...initialState.answer
            }
        },
        setSetting: ({setting}, action) => {
            setting.data = action.payload;
            setting.status = SUCCESS;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(getSettingByHWId.pending, ({setting}) => {
                setting.status = LOADING
            })
            .addCase(getSettingByHWId.fulfilled, ({setting}, action) => {
                setting.status = SUCCESS
                setting.data = action.payload
            })
            .addCase(getSettingByHWId.rejected, ({setting}, action) => {
                setting.status = FAILED
                setting.message = errorConverter(action)
            })
            //---------------------------------------------------------------------
            .addCase(getTask.pending, ({task}) => {
                task.status = LOADING
            })
            .addCase(getTask.fulfilled, ({task}, action) => {
                task.status = SUCCESS
                task.data = action.payload
            })
            .addCase(getTask.rejected, ({task}) => {
                task.status = FAILED
            })
            //---------------------------------------------------------------------
            .addCase(sendAnswer.pending, ({answer}) => {
                answer.status = LOADING
            })
            .addCase(sendAnswer.fulfilled, ({answer}, action) => {
                answer.status = SUCCESS
                answer.data = action.payload
            })
            .addCase(sendAnswer.rejected, ({answer}) => {
                answer.status = FAILED
            })
    }
})


export const {
    clearGameState,
    setTheme,
    setSolveType,
    setTaskType,
    setComplexity,
    setLength,
    setSpeed,
    setClearTask,
    setClearAnswer,
    setSetting,
} = gameReducer.actions
export default gameReducer.reducer